import type { FaireProductEntity } from "../../entity_types/product";

export const p_7uqzznhdev: FaireProductEntity = {
  token: "p_7uqzznhdev",
  type: "product",
  name: "Happy Plaid Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9119423281afd4b73caf23844a3cb9d235bf55b13e8c900ffa360225904a315a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b325be49a1801bad1bb56870356c480b869f540fab1ef5bc3fa7a98da39d82b5.jpeg",
    "https://cdn.faire.com/fastly/826adf5f904dbc7030be0d0a9795022f016c7da03397ae18f8461b00edf52430.jpeg",
    "https://cdn.faire.com/fastly/118eceb5cba2c697b1e6d02a2d14c4b9da78cf574ad413f7c968051b35e7166d.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:25.238Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
